import request from "@/utils/request";

export function getAgoraChannelInfo(params = {}) {
    return request({
        method: "get",
        url: `/upload/agora/join/`,
        data: params
    });
}
export function agoraRecordingStart(params = {}) {
    return request({
        method: "post",
        url: `/upload/agora/recording/start/`,
        data: params
    });
}
export function agoraRecordingStop(params = {}) {
    return request({
        method: "post",
        url: `/upload/agora/recording/stop/`,
        data: params
    });
}
export function agoraRecordingQuery(params = {}) {
    return request({
        method: "post",
        url: `/upload/agora/recording/query/`,
        data: params
    });
}
export function agoraRecordingSids(params = {}) {
    return request({
        method: "post",
        url: `/upload/agora/recording/sids/`,
        data: params
    });
}
